import { useTranslation } from "react-i18next";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    CircularProgress,
    useTheme,
} from "@mui/material";

import { Button } from "@foodpilot/foods";

type DeleteConfirmDialogProps = {
    open: boolean;
    onClose: () => void;
    onConfirmDelete: () => void;
    isDeleting: boolean;
    pageName?: string;
};

export const DeleteConfirmDialog = (props: DeleteConfirmDialogProps) => {
    const { open, onClose, onConfirmDelete, isDeleting, pageName } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                {pageName && (
                    <Typography variant="body1" fontSize={18} fontWeight={theme.typography.fontWeightMedium}>
                        {t("settings.cms.pages.delete_dialog.title", { pageName })}
                    </Typography>
                )}
            </DialogTitle>
            <DialogContent>
                {pageName && (
                    <Typography variant="body1" sx={{ mb: 2, fontWeight: "medium" }}>
                        {pageName}
                    </Typography>
                )}
                <Typography>{t("settings.cms.pages.delete_dialog.message")}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onConfirmDelete}
                    variant="primary"
                    sx={{
                        background: `linear-gradient(${theme.palette.error[900]}, ${theme.palette.error[700]})`,
                    }}
                >
                    {isDeleting ?
                        <CircularProgress size={24} />
                    :   t("settings.cms.pages.delete_dialog.confirm")}
                </Button>
                <Button onClick={onClose} variant="ternary">
                    {t("settings.cms.pages.delete_dialog.cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
